'use client'

import { ConfigProvider, theme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { StyleProvider } from '@ant-design/cssinjs'

export default function AntdProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          borderRadius: 8,
          colorPrimary: '#CFF94F',
          // colorPrimaryBorder: '#CFF94F',
          // colorPrimaryBorderHover: '#CFF94F',
        },
      }}
    >
      {/* https://github.com/ant-design/ant-design/issues/38794#issuecomment-1328262525 */}
      <StyleProvider hashPriority="high">{children}</StyleProvider>
    </ConfigProvider>
  )
}
